<template>
  <div class="modal show">
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ getTitle }}
          </h5>
        </div>
        <div class="modal-body">
          <button
            class="btn btn-primary"
            @click.stop="submitConfirm()"
          >
            Ja
          </button>
          <button
            class="btn btn-primary"
            @click.stop="submitDismiss()"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Sind Sie sicher?'
    }
  },
  computed: {
    getTitle () {
      return this.text
    }
  },
  methods: {
    submitDismiss () {
      this.$emit('update', false)
    },
    submitConfirm () {
      this.$emit('update', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.show {
  display: block;
  background-color: rgba(0, 0, 0, .5)
}

.modal-body {
  display: block;
  float: right;
  margin-left: auto;
}
</style>
